import type { StudyPlanType } from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class StudyPlanDao {
  static async setStudyPlan(
    env: Environment,
    personId: number,
    studyPlanType: StudyPlanType
  ) {
    const url = hostsConfig[env].profileServiceUrl;
    const { data } = await axios.put<string>(`${url}/v1/persons/specific`, {
      studyPlanType: studyPlanType.toUpperCase(),
      personId,
    });
    return data;
  }
}
